import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import PageTemplateComponent from "../../../../components/page-template/page-template.component";
import CategoriesPageStyled from "./ingredients.page.styled";
import { observer } from 'mobx-react-lite';
import { useStore } from "../../../../hooks/store.hook";
import { PanelType } from "../../../../enums/panel-type.enum";
import CategoryPanelStyled from "../../../../components/category-panel/category-panel.component.styled";
import CategoryPanel from "../../../../components/category-panel/category-panel.component";
import { getAllCategories, getAllIngredients } from "../../../../utils/requests";
import { TableTypeEnum } from "../../../../enums/table-type.enum";
import TableComponent, { ActionItemPropsType, CustomRendererPropsType, TableDataPropsType } from "../../../../components/table/table.component";
import { HeaderTypeEnum } from "../../../../enums/header-type.enum";
import { EditOutlined } from "@mui/icons-material";
import IngredientPanel from "../../../../components/ingredient-panel/ingredient-panel.component";
import { displayCustomToast } from "../../../../utils/display-custom-toast";

const IngredientsPage = observer(() => {

    // Ingrediente
    const [refreshData, setRefreshData] = useState<boolean>(true);
    const [data, setData] = useState<any>();
    const [dataLoading, setDataLoading] = useState<boolean>(true);
    const [filtersTable, setFilters] = useState<any>({
          pageIndex: 0,
          pageSize: 5,
        //   selectFilterValue: null,
        //   secondSelectFilterValue: null,
        //   tabFilterValue: undefined,
          searchText: null
    });
    const uiStore = useStore('uiStore');
    const [actionItemsClick, setActionItemsClick] = useState<any>();

    const createData = useCallback(
        () => {
            uiStore.openPanel({
                key: PanelType.CreateIngredient,
                component: <IngredientPanel />,
                panelWidth: '700px',
                title: `Creare ingredient`,
                onDismiss: (data: any) => {
                    if(!data) return;
                    
                    if(data?.refreshData)
                        setRefreshData(() => true);
                }
            });
        },
        []
    )

    useEffect(
        () => {
            async function getData() {
                try {
                    setDataLoading(() => true)
                    let fetchJobs = await getAllIngredients({
                        pageIndex:filtersTable.pageIndex + 1,
                        pageSize:filtersTable.pageSize,
                        searchText:filtersTable.searchText
                    });
                    setData(() => fetchJobs)
                    setDataLoading(() => false)
                } catch (error: any) {
                    displayCustomToast(error.content, true);
                    setDataLoading(() => false)
                }
            }
            
            if(!refreshData) return;

            getData();
            setRefreshData(() => false);
            
        },
        [filtersTable, refreshData]
    )

    const tableData = useMemo(
        (): TableDataPropsType => {
            if(!data) return {
                data: [],
                headers: []
            }

            return {
                data: data.data,
                headers: [
                   {
                        id: 'name',
                        label: 'Nume',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'left',
                        sortable: false
                    },
                   {
                        id: 'measurementUnitType',
                        label: 'Tip unitate de masura',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'center',
                        sortable: false
                    },
                   {
                        id: 'measurementUnit',
                        label: 'Unitate de masura',
                        headerType: HeaderTypeEnum.String,
                        alignment: 'center',
                        sortable: false
                    }
                ],
                totalElements: data.totalNumber
            }
        },
        [data]
    )

    const actionItems: ActionItemPropsType[] = useMemo(
        () => {
            return [
                {
                    text: "Editeaza Ingredient",
                    icon: <EditOutlined />,
                    color: "black",
                    fOnClick: (row: any) => {
                        uiStore.openPanel({
                            key: PanelType.EditIngredient,
                            component: <IngredientPanel 
                                ingredientId={row.id}
                                ingredientDetails={row}
                            />,
                            panelWidth: '700px',
                            title: `Editeaza ingredientul: ${row.name}`,
                            onDismiss: (data: any) => {
                                if(!data) return;
                                
                                if(data?.refreshData)
                                    setRefreshData(() => true);
                            }
                        });
                    }
                }
            ]
        },
        [actionItemsClick]
    )

    const customRenderer: CustomRendererPropsType = {
        measurementUnit: (row: any) => {
            return (
                <>
                    {row.measurementUnit.name}
                </>
            )
        },
        measurementUnitType: (row: any) => {
            return (
                <>
                    {row.measurementUnitType.name}
                </>
            )
        },
    }

    /** define the state bellow */
    return (
        <CategoriesPageStyled>
            <PageTemplateComponent 
                title="Ingrediente"
                buttons={[
                    {
                        fOnClick: () => {
                            createData()
                        },
                        text: "Creeaza"
                    }
                ]}
            >
                <TableComponent
                    tableKey={TableTypeEnum.AllIngredients} 
                    viewType="normal"
                    tableData={tableData}
                    searchBarPlaceholder="Cauta dupa nume"
                    withoutSelect
                    isLoading={dataLoading}
                    tableState={filtersTable}
                    setTableState={setFilters}
                    actionItems={actionItems}
                    actionItemsClick={setActionItemsClick}
                    setRefreshData={setRefreshData}
                    customRenderer={customRenderer}
                />  
            </PageTemplateComponent>
        </CategoriesPageStyled>
    )

})

export default IngredientsPage;